import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TcNav from "./TcNav";
import "../../styles/tcDash.css";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
function AddCase() {
  // Hook to navigate
  const navigate = useNavigate();
  const [laws, setLaws] = useState([]);
  const [stations, setStations] = useState([]);

  const getStations = async () => {
    try {
      const response = await fetch("http://localhost:8000/policestation");
      const data = await response.json();
      setStations(data);
    } catch (error) {
      console.error("Error fetching stations data:", error);
    }
  };

  const getLaws = async () => {
    try {
      const response = await fetch("http://localhost:8000/laws");
      const data = await response.json();
      setLaws(data);
    } catch (error) {
      console.error("Error fetching violations data:", error);
    }
  };

  useEffect(() => {
    // Call the function to fetch laws and stations
    getStations();
    getLaws();
  }, []);

  const [formData, setFormData] = useState({
    caseID: "",
    licenseNo: "",
    date: "",
    violated: "",
    fines: "",
    location: "",
    status: "unresolved",
    request: "no",
    
  });

  // Function to handle changes in input fields
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.warn(formData);
    try {
      
      // Send a POST request to the server with form data
      let result = await fetch("http://localhost:8000/case", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
        },
      });

      // Parse the response as JSON
      result = await result.json();

      // If successful, save user data in local storage and navigate to dashboard
      if (result) {
        toast.success("New Case Added", {
          position: "top-left",
          autoClose: 2000,
          theme: "dark",
        });
        // Reset the form fields to their initial state
        setFormData({
          caseID: "",
          licenseNo: "",
          date: "",
          violated: "",
          fines: "",
          location: "",
          status: "unresolved",
          request: "no",
          
        });
      }
    } catch (error) {
      console.error("Error during fetch operation:", error);
    }
  };

  return (
    <div>
      <header>
        <TcNav />
      </header>
      <main>
        {/* Cases */}
        <section className="searches">
          <div className="container mt-5 pt-1">
            <div className="row">
              <div className="col-12 col-sm-7 col-md-6 m-auto">
                <div className="card border-0 shadow custom-card">
                  <div className="card-body p-4  text-light">
                    {/* User Icon */}
                    <div className="d-flex justify-content-center mt-4 mb-4">
                      <i className="fa-solid fa-user"></i>
                    </div>

                    {/* Input fields for user information */}
                    <form onSubmit={handleSubmit}>
                      <input
                        type="text"
                        className="form-control mt-2"
                        placeholder="Case No"
                        name="caseID"
                        value={formData.caseID}
                        onChange={handleChange}
                      />

                      <input
                        type="text"
                        name="licenseNo"
                        className="form-control col mt-2"
                        placeholder="License No"
                        value={formData.licenseNo}
                        onChange={handleChange}
                      />

                      <input
                        type="date"
                        className="form-control mt-2"
                        placeholder="Violation Date"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                      />

                      {/* police station list */}
                      <select
                        className="form-select mt-2"
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                      >
                        <option selected>Select Location</option>
                        {stations.map((station) => (
                          <option key={station.id} value={station.name}>
                            {station.name}
                          </option>
                        ))}
                      </select>

                      {/* laws */}
                      <select
                        className="form-select mt-2"
                        aria-label="Default select example"
                        name="violated"
                        value={formData.violated}
                        onChange={handleChange}
                      >
                        <option selected>Select Violation Type</option>
                        {laws.map((law) => (
                          <option key={law.id} value={law.violations}>
                            {law.violations}
                          </option>
                        ))}
                      </select>

                      <div className="text-center mt-4">
                        <button
                          type="submit"
                          className="btn btn-outline-light w-100"
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Case Alert */}
        <section className="mt-2">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-7 col-md-6 m-auto">
                <div
                  class="alert alert-info d-flex align-items-center"
                  role="alert"
                >
                  For MULTIPLE VIOLATION by the same person, kindly input each
                  incident into the system individually.
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <ToastContainer />
    </div>
  );
}

export default AddCase;
